<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h4 class="modal-title">Cancel Recurring Invoice</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12 p-2">
        <div class="card">
          <div class="card-body">
            <div class="form-group">
              <strong>Invoice Number: </strong>
              <span class="invoice_invoicenumber_text"
                >{{ invoiceModel.invoiceNumber || invoiceModel.InvoiceNumber }}
              </span>
            </div>
            <br />
            <div class="form-group">
              <label
                ><strong>Please provide reason for cancellation.</strong></label
              >
              <span *ngIf="loadingcancellationReason"
                ><i class="fas fa-spinner fa-spin"></i
              ></span>
              <div *ngFor="let item of reasons">
                <input
                  class="invoice_cancellationreason_radio"
                  type="radio"
                  name="cancellationReason"
                  id="cancellationReason-{{ item.id }}"
                  value="{{ item.id }}"
                  (click)="cancelReasonChanged(item.id, item.description)"
                  [(ngModel)]="cancelModel.CancellationReasonId"
                />&nbsp;&nbsp;<label for="cancellationReason-{{ item.id }}">
                  {{ item.description }}</label
                >
              </div>
            </div>
            <br />
            <div class="form-group">
              <label><strong>Cancellation Reason: </strong></label>
              <textarea
                [(ngModel)]="cancelModel.Reason"
                row="3"
                class="form-control invoice_cancellationreason_input"
              ></textarea>
            </div>
            <div class="form-group" *ngIf="displayApprovalNotes">
              <label><strong>Approval Remarks: </strong></label>
              <textarea
                [(ngModel)]="cancelModel.ApprovalNotes"
                row="3"
                class="form-control"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline invoice_savecancellation_button"
      [disabled]="busy"
      (click)="save()"
    >
      Save
    </button>
  </div>
</div>
